module.exports = __webpack_public_path__ + "static/media/40x40-14.fc9622a5.png";